module.exports = __webpack_public_path__ + "media/images/landing_page/2023/main_home_image-f1a7db84d73564fe922cc9bd046af231.png";